import { useEffect, useState } from 'react';

const DEFAULT_FIXED_TITLE_HEIGHT = 56;

const resultsLabel = ({ total, position }) => {
  if (total === 0) return null;
  return `${total > 1 ? `${position} of ` : ''}${total} result${total === 1 ? '' : 's'}`;
};

const TranscriptSearchBar = ({ search, fixedTitleRef }) => {
  const { inputValue, changeInput, submit, clear, next, prev, status, total, position } = search;
  const [stickyTop, setStickyTop] = useState(DEFAULT_FIXED_TITLE_HEIGHT);

  useEffect(() => {
    const fixedTitle = fixedTitleRef.current;
    if (!fixedTitle || typeof ResizeObserver === 'undefined') return;
    const measure = () => fixedTitle.offsetHeight && setStickyTop(fixedTitle.offsetHeight);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(fixedTitle);
    return () => observer.disconnect();
  }, [fixedTitleRef]);

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') e.stopPropagation();
    if (e.key !== 'Enter') return;
    if (e.shiftKey) prev();
    else submit();
  };

  const label = resultsLabel({ total, position });

  return (
    <div
      className='transcript-search-bar bg-main-white border-bottom position-sticky px-4 specific-y-padding-12'
      style={{ top: stickyTop }}
    >
      <div className='flex-centered'>
        <div className='flex-grow-1 flex-centered transcript-search-input border bg-main-white rounded-pill px-3'>
          <span className='icon-search title-h5-m mr-2' style={{ color: '#9c9c9c' }} />
          <input
            className='search-main-input w-100'
            data-hj-allow
            type='text'
            value={inputValue}
            onChange={(e) => changeInput(e.target.value)}
            onKeyDown={handleKeyDown}
            spellCheck={false}
            placeholder='Search transcript'
            aria-label='Search transcript'
          />
          {status === 'loading' ? (
            <i className='fas fa-spinner fa-spin d-inline-block-centered flex-shrink-0' />
          ) : (
            inputValue !== '' && (
              <button
                className='general-button close-icon flex-shrink-0'
                aria-label='Clear search'
                data-tooltip-content='Clear search'
                data-tooltip-id='general-tooltip'
                onClick={clear}
              />
            )
          )}
        </div>
        {label && <p className='mb-0 ml-3 nowrap-item'>{label}</p>}
        {total > 0 && (
          <div className='flex-centered total-contributions-buttons ml-2'>
            <button className='general-button total-contributions-prev' aria-label='Previous result' onClick={prev}>
              <span className='icon-arrow-back' />
            </button>
            <button className='general-button total-contributions-next' aria-label='Next result' onClick={next}>
              <span className='icon-arrow-next' />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TranscriptSearchBar;
